
define('ldsh!modules/form_editor/templates/preview_custom_fblogin_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<script async custom-element="amp-access" src="https://cdn.ampproject.org/v0/amp-access-0.1.js"></script>\n<script id="amp-access" type="application/json">\n  {\n    "authorization": "https://ampbyexample.com/oauth/status?_=RANDOM",\n    "noPingback": "true",\n    "login": {\n      "facebook-sign-in": "https://ampbyexample.com/oauth/login/facebook"\n    },\n    "authorizationFallbackResponse": {\n      "error": true,\n      "loggedIn": false\n    }\n  }\n</script>\n\n<div amp-access="NOT loggedIn" amp-access-hide>\n  <div class="ed-item-socialbox ed-item-socialbox-h ' +
((__t = ( position )) == null ? '' : __t) +
'">\n    <div id="' +
((__t = ( idName )) == null ? '' : __t) +
'"\n         class="ed-social-block ed-facebook-login fb-login-button size-' +
((__t = ( size )) == null ? '' : __t) +
' fb_img"\n         scope="email"\n         data-max-rows="1"\n         data-size="' +
((__t = ( size )) == null ? '' : __t) +
'"\n         data-show-faces="false"\n         data-auto-logout-link="false"\n         on="tap:amp-access.login-facebook-sign-in"></div>\n  </div>\n</div>\n\n\n';

}
return __p
};});

